import { React, useState, useEffect } from "react";
import { Button, Form, Input, Select, Col, Row, Checkbox } from "antd";
import Iconmoon from "../../../../Components/IconsFiles/icon";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
  ProductionSet,
  DropDownSearchDraw,
} from "../../../styledElements";
import RightDrawerSidebar from "../../../../Components/RightDrawer/rightDrawer";
import { DatePicker, Dropdown, Space, Divider, theme } from "antd";
import { DatePickerY, GlobalSet, DisabledStyles } from "../../../pageStyled";
import {
  getJumboReelsForMapping,
  getParentReelDetailsById,
  mapJumboReel,
  mapJumboReelForCutter,
  removeJumboReelMapping,
} from "../../../../Services/productionPlanningServices";
import moment from "moment";
import warning from "../../../../Assets/Icons/warning.png";
import ConfirmationModal from "../../../../Components/Modal/ConfirmationModal";
import AlertContainer from "../../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../../Assets/Icons/alertRed.svg";
import {
  lengthUnit,
  weightUnit,
  orderDim_Rewinder_Unit_Conversion,
  CoversionFactorUnitsToCM,
  CoversionFactorCMToUnits
} from "../../../../Utils/Constant/MeasurementUnitList";
import { useNavigate, useLocation } from "react-router";

const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);
const { Option } = Select;
const { TextArea } = Input;
const shiftData = ["1st", "2nd", "3rd"];

const MapToJumboDrawer = ({
  jobId,
  parentReelId,
  visible,
  onCloseMapToReel,
  setActionResponse,
  showToaster,
  reFetch,
  type,
  data,
  drawerState,
  machineCode,
  productCode,
  productSpec,
  parentWeight,
  parentWeightUnit,
  savedDate,
  savedShift,
  jobcardType,
  selectedMachineType,
  tabNo,
  jobCardPly
}) => {
  const location = useLocation();
  const history = useNavigate();
  const [parentReelDetails, setParentReelDetails] = useState();
  const [visibleModal, setVisibleModal] = useState(false);
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);
  const [jumboReelData, setJumboReelData] = useState([]);
  const [mappedJumboRolls, setMappedJumboRolls] = useState([
    { number: null, weight_utilized: null, units: null },
  ]);
  const [action, setAction] = useState("");
  const [responseError, setResponseError] = useState("");
  const [jumboRoleDropdown, setJumboRoleDropdown] = useState(false);
  const [alert, setAlert] = useState(false);
  const [response, setResponse] = useState();
  const [isSaving, setIsSaving] = useState(false)
  const [rerender, setRerender] = useState(false);
  const [requiredDeckle, setRequiredDeckle] = useState();

  // const [isDrawerOpened, setIsDrawerOpened] = useState(drawerState ? drawerState : false);
  const [form] = Form.useForm();

  const mapParentReel = (body, machineType) => {
    if (machineType !== "cutter" || tabNo == 6) {
      mapJumboReel(body, type)
        .then((response) => {
            setActionResponse({
              error: response.data.error,
              msg: "Mapping is successfully saved",
            });
            showToaster();
            reFetch(true);
            setResponseError("");
            form.resetFields();
            onCloseMapToReel();
        })
        .catch((error) => {
          console.log(error);
          // setActionResponse(error.response.data);
          if(error.response.data.error_msg && error.response.data.error_msg !== ""){
            setConfirmModalVisible(true);
          } else{
            showResponseError(error.response.data.msg);
          }
          // showToaster();
        }).finally(()=> setIsSaving(false));
    } else {
      mapJumboReelForCutter(body, type)
        .then((response) => {
          setActionResponse({
            error: response.data.error,
            msg: "Mapping is successfully saved",
          });
          showToaster();
          reFetch(true);
          setResponseError("");
          form.resetFields();
          onCloseMapToReel();
        })
        .catch((error) => {
          console.log(error);
          // setActionResponse(error.response.data);
          // showResponseError(error.response.data.msg);
          // showToaster();
          if(error.response.data.error_msg && error.response.data.error_msg !== ""){
            setConfirmModalVisible(true);
          } else{
            showResponseError(error.response.data.msg);
          }
        }).finally(()=> setIsSaving(false));
    }
  };

  const removeMapping = (body) => {
    removeJumboReelMapping(body)
      .then((response) => {
        setActionResponse({
          error: response.data.error,
          msg: response.data.msg,
        });
        showToaster();
        reFetch(true);
        setResponseError("");
        form.resetFields();
        onCloseMapToReel();
      })
      .catch((error) => {
        console.log(error);
        showResponseError(error.response.data.msg);
        // setActionResponse(error.response.data);
        // showToaster();
      });
  };

  const showResponseError = (value) => {
    setResponseError(value);
    setTimeout(() => setResponseError(""), 3000);
  };

  const showModal = () => {
    setVisibleModal(true);
  };

  const modalClose = () => {
    setVisibleModal(false);
    // setIsDrawerOpened(false);
  };

  const modalConfirm = () => {
    handleSubmit("remove");
    setVisibleModal(false);
  };

  const handleModalClose = () => {
    setConfirmModalVisible(false);
  };
  
  const handleModalConfirm = () => {
    //call API
    setConfirmModalVisible(false);
    setIsSaving(true);
      if (mappedJumboRolls && mappedJumboRolls?.length) {
        if ((tabNo == 6 || parentReelDetails?.machine_type !== "cutter")) {
          mapParentReel(
            {
              parent_reel_id: parentReelId,
              rewinding_date: moment(form.getFieldValue("date")).format("YYYY-MM-DD"),
              rewinding_shift: form.getFieldValue("rewindingShift"),
              jumbo_reels: mappedJumboRolls,
              override_mapping: true
            },
            parentReelDetails?.machine_type
          );
        } else {
          mapParentReel(
            {
              parent_reel_id: parentReelId,
              cutting_date: moment(form.getFieldValue("cuttingDate")).format("YYYY-MM-DD"),
              cutting_shift: form.getFieldValue("cuttingShift"),
              jumbo_reels: mappedJumboRolls,
              override_mapping: true
            },
            parentReelDetails?.machine_type
          );
        }
      } else {
        setResponse({
          error: true,
          msg: "Please add jumbo reels",
        });
        setAlert(true);
        setTimeout(() => {
          setAlert(false);
        }, 3000);
      }
  };

  const handleSubmit = (option) => {
    setAction(option);
    form.submit();
  };

  const onFinish = (event) => {
    if (action === "remove") {
      removeMapping({
        parent_reel_id: parentReelId,
      });
    } else if (action === "save") {
      setIsSaving(true);
      if (mappedJumboRolls && mappedJumboRolls?.length) {
        if ((tabNo == 6 || parentReelDetails?.machine_type !== "cutter")) {
          mapParentReel(
            {
              parent_reel_id: parentReelId,
              rewinding_date: moment(event.date).format("YYYY-MM-DD"),
              rewinding_shift: event.rewindingShift,
              jumbo_reels: mappedJumboRolls,
              override_mapping: false
            },
            parentReelDetails?.machine_type
          );
        } else {
          mapParentReel(
            {
              parent_reel_id: parentReelId,
              cutting_date: moment(event.cuttingDate).format("YYYY-MM-DD"),
              cutting_shift: event.cuttingShift,
              jumbo_reels: mappedJumboRolls,
              override_mapping: false
            },
            parentReelDetails?.machine_type
          );
        }
      } else {
        setResponse({
          error: true,
          msg: "Please add jumbo reels",
        });
        setAlert(true);
        setTimeout(() => {
          setAlert(false);
        }, 3000);
      }
    }
  };

  const addJumboRoll = () => {
    let arry = [...mappedJumboRolls];
    let arr = [];
    arr = [...arry,{number: null, weight_utilized: null, units: null}];
    if(arr.length == 1){
      let unitObj = {
        weight_utilized: parentReelDetails?.units?.weight
      };
      arr[0]["weight_utilized"] = parseFloat(parentReelDetails?.weight?.toFixed(3));
      arr[0]["units"] = unitObj;
      form.setFieldsValue({ [`jumboRoll0`]: null, [`weight0`]: parseFloat(parentReelDetails?.weight?.toFixed(3)) });
    }
    setMappedJumboRolls(arr);
    // form.setFieldsValue({ [`jumboReel0`]: null, [`weight0`]: null });
    // setMappedJumboRolls([
    //   ...mappedJumboRolls,
    //   { number: null, weight_utilized: null, units: null },
    // ]);
  };

  const deleteJumboRoll = (key) => {
    form.setFieldsValue({ [`jumboReel${key}`]: null, [`weight${key}`]: null });
    setMappedJumboRolls(mappedJumboRolls.filter((item, index) => index !== key)
    );
    form.setFieldsValue({ [`jumboRoll${key}`]: null });
  };
  const handleJumboRollChange = (index, newValue) => {
    // console.log(newValue, index);
    setMappedJumboRolls((prevMappedJumboRolls) => {
      const updatedJumboRolls = prevMappedJumboRolls.map((obj, key) => {
        if (key === index) {
          return {
            ...obj,
            number: newValue,
          };
        }
        return obj;
      });
      form.setFieldsValue({
        [`jumboRoll${index}`]: newValue,
      });

      return updatedJumboRolls;
    });
  };

  const creteNewJumbo = () => {
    let selectedDate = '';
    let selectedShift
    if(parentReelDetails.machine_type === "rewinder"){
      let dateValue = form.getFieldValue("date");
      if (dateValue)
        selectedDate = moment(dateValue, "DD/MM/YYYY").format("YYYY-MM-DD");
      selectedShift = form.getFieldValue("rewindingShift");
    }
    history("../jumbo-reel-records/add-new-jumbo-reel", {
      state: {
        rootPage: jobcardType == "single_stage" ? "../production-job-cards/job-card-details" : "../production-job-cards/multi-stage-job-card-details",
        parentPage: "productionDetails",
        id: jobId,
        parentReelId: parentReelId,
        actionFrom: "mapping drawer",
        type: type,
        machineCode: machineCode,
        productCode: productCode,
        productSpec: productSpec,
        // widthKey: (parentReelDetails.size + parentReelDetails.left_edge_trim + parentReelDetails.right_edge_trim),
        widthKey: requiredDeckle,
        widthUnit: parentReelDetails.units.size,
        parentWeight: parentReelDetails?.weight,
        parentWeightUnit: parentReelDetails?.units?.weight,
        selectedDate: selectedDate,
        selectedShift: selectedShift,
        jobcardType: jobcardType,
        machineType: parentReelDetails.machine_type
      },
    });
  };

  // useEffect(() => {
  //   console.log(mappedJumboRolls);
  // }, [mappedJumboRolls]);
  const onJumboRoleDropdown = () => {
    setJumboRoleDropdown((prevState) => !prevState);
  };

  useEffect(() => {
    setResponseError("");
    form.resetFields();
    if (jobId) {
      getJumboReelsForMapping(jobId, jobcardType)
        .then((response) => {
          const data = response.data.data.map((item) => {
            return {
              number: item.number,
              remainingWeight: item.weight,
              weight: item.units && item.units.weight ? item.units.weight : "T",
            };
          });
          setJumboReelData(data);
        })
        .catch((error) => console.log(error));
    }
    return () => {
      setJumboReelData([]);
    };
  }, [parentReelDetails]);

  useEffect(() => {
    setResponseError("");
    form.resetFields();
    if (parentReelId) {
      getParentReelDetailsById(parentReelId)
        .then((response) => {
          if(jobcardType == "single_stage"){
            let edgeTrimAdd = response.data.data.left_edge_trim + response.data.data.right_edge_trim;
            let convertedEdgeTrim = edgeTrimAdd * CoversionFactorUnitsToCM[response.data.data.units.left_edge_trim];
            let convertedSize = response.data.data.size * CoversionFactorUnitsToCM[response.data.data.units.size];
            let convertedDeckleInCM = convertedSize + convertedEdgeTrim;
            let convertedReqDeckle = convertedDeckleInCM * CoversionFactorCMToUnits[response.data.data.units.size];
            setRequiredDeckle(convertedReqDeckle? convertedReqDeckle?.toFixed(3) : "");
          } else{
            let convertedNetTrim = response.data.data.net_trim_loss * CoversionFactorUnitsToCM[response.data.data.units.net_trim_loss];
            let convertedDComWidth = response.data.data.d_com_width * CoversionFactorUnitsToCM[response.data.data.units.d_com_width];
            let convertedDeckleInCM = convertedNetTrim + convertedDComWidth;
            let convertedReqDeckle = convertedDeckleInCM * CoversionFactorCMToUnits[response.data.data.units.d_com_width];
            setRequiredDeckle(convertedReqDeckle ? convertedReqDeckle?.toFixed(3) : "");
          }
          if(!(drawerState && type == "add")){
            setMappedJumboRolls(
              response.data.data.mapped_jumbo_reels_info.map((item) => {
                return {
                  number: item.number,
                  weight_utilized: parseFloat(item.weight_utilized),
                  units: item.units,
                };
              })
            );
          }          
          setParentReelDetails(response.data.data);
        })
        .catch((error) => console.log(error));
    }
    return () => {
      setParentReelDetails();
      setMappedJumboRolls([]);
    };
  }, [parentReelId]);


  useEffect(() => {
    if(drawerState && type == "add"){
      let unitObj = {
        weight_utilized: parentWeightUnit
      };
      let jumboReelsObj = { 
        number: data.number, 
        weight_utilized: parseFloat(parentWeight?.toFixed(3)), 
        units: unitObj
      };
      let jrArr = [];
      jrArr.push(jumboReelsObj);
      form.setFieldsValue({ [`jumboRoll0`]: data.number });
      if(selectedMachineType == "rewinder"){
        let dateValue = "";
        if(savedDate)
          dateValue = moment(savedDate,"YYYY-MM-DD");
        form.setFieldsValue({"date": dateValue});
        form.setFieldsValue({"rewindingShift": savedShift});
      }
      setMappedJumboRolls(jrArr);
      setRerender(true);
    }
  },[drawerState]);

  useEffect(() => {
    let temp = mappedJumboRolls;
    setRerender(false);
  },[mappedJumboRolls])
  // useEffect(() => {
  //   form.resetFields();
  // }, [mappedJumboRolls]);

  return parentReelDetails && jumboReelData ? (
    <RightDrawerSidebar
      title="Map to Jumbo Roll"
      subtitle=""
      visible={visible}
      onClose={() => {
        setResponseError("");
        form.resetFields();
        onCloseMapToReel();
      }}
    >
      {alert && (
        <AlertContainer
          color={response.error ? "red" : "green"}
          icon={response.error ? alertRed : alertGreen}
          msg={response.msg}
        />
      )}
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          <DetailFields className="marginBtnP">
            <HaberForm>
              <Form
                form={form}
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "0" }}
                onFinish={onFinish}
              >
                <div
                  className="drawerField"
                  style={{ paddingTop: "5px", paddingBottom: "15px" }}
                >
                  <div className="titleWithText titlebytwo">
                    {(tabNo == 6 || parentReelDetails.machine_type !== "cutter") ? (
                      <h5>Parent Reel: {parentReelDetails.id}</h5>
                    ) : (
                      <h5>Parent Set: {parentReelDetails.id}</h5>
                    )}
                    <p>
                      Weight: {parentReelDetails?.weight.toFixed(3)}{" "}
                      {parentReelDetails?.units &&
                      parentReelDetails?.units?.weight
                        ? capitalize(
                            weightUnit[parentReelDetails.units.weight]
                              ?.displayName
                          )
                        : "T"}
                    </p>
                  </div>
                </div>
                <div className="drawerField">
                  {(tabNo == 6 || parentReelDetails.machine_type === "rewinder") ? (
                    <div className="titleWithText">
                      <h5>Rewinding Date & Shift</h5>
                      <p>The reel will be rewinded on selected date and shift</p>
                    </div>
                  ) : (
                    <div className="titleWithText">
                      <h5>Cutting Date & Shift</h5>
                      <p>The sheet will be cut on selected date and shift</p>
                    </div>
                  )}

                {(tabNo == 6 || parentReelDetails.machine_type === "rewinder") ? (
                <Row className="centerAlign justifyCSBetween">
                    <Col span={12}>
                      <DatePickerY>
                        <Form.Item
                          name="date"
                          className="dBlock"
                          rules={[
                            {
                              required: true,
                              message: "This is a mandatory field",
                            },
                          ]}
                          initialValue={ 
                            type == "edit" ? 
                            parentReelDetails.rewinding_date
                              ? moment(
                                  parentReelDetails.rewinding_date,
                                  "YYYY-MM-DD"
                                )
                              : null  : 
                                drawerState ? (savedDate ? moment(savedDate,"YYYY-MM-DD") : "") : ""
                          }
                        >
                          <DatePicker
                            format={"DD-MM-YYYY"}
                            disabledDate={(current) => {
                              return (
                                current && current < moment().subtract(1, "day")
                              );
                            }}
                          />
                        </Form.Item>
                        <p style={{marginTop:"-24px"}}>Date</p>
                      </DatePickerY>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType" style={{marginTop:"3px", paddingLeft:"3px"}}>
                        <Form.Item
                          name="rewindingShift"
                          rules={[]}
                          className="selectForm"
                          initialValue={type == "edit" ? parentReelDetails.rewinding_shift : drawerState ? savedShift : ""}
                        >
                          <Select
                            placeholder="Select shift"
                            suffixIcon={<DownArrowDraw />}
                          >
                            {shiftData?.map((shift) => (
                              <Option key={shift}>{shift}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                        <p style={{marginTop:"-26px"}}>Shift</p>
                      </div>
                    </Col>
                </Row>) : (
                  <Row className="centerAlign justifyCSBetween">
                    <Col span={12}>
                      <DatePickerY>
                        <Form.Item
                          name="cuttingDate"
                          className="dBlock"
                          rules={[
                            {
                              required: true,
                              message: "This is a mandatory field",
                            },
                          ]}
                          initialValue={
                            parentReelDetails.cutting_date
                              ? moment(
                                  parentReelDetails.cutting_date,
                                  "YYYY-MM-DD"
                                )
                              : null
                          }
                        >
                          <DatePicker
                            format={"DD-MM-YYYY"}
                            disabledDate={(current) => {
                              return (
                                current && current < moment().subtract(1, "day")
                              );
                            }}
                          />
                        </Form.Item>
                        <p style={{marginTop:"-24px"}}>Date</p>
                      </DatePickerY>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType" style={{marginTop:"3px", paddingLeft:"3px"}}>
                      <Form.Item
                        name="cuttingShift"
                        rules={[]}
                        className="selectForm"
                        initialValue={parentReelDetails.cutting_shift}
                      >
                        <Select
                          placeholder="Select"
                          suffixIcon={<DownArrowDraw />}
                        >
                          {shiftData?.map((shift) => (
                            <Option key={shift}>{shift}</Option>
                          ))}
                        </Select>
                      </Form.Item>
                      <p style={{marginTop:"-26px"}}>Shift</p>
                      </div>
                    </Col>
                  </Row>
                )}

                  {/* {parentReelDetails.machine_type === "rewinder" ? (
                    <DatePickerY>
                      <Form.Item
                        name="date"
                        className="dBlock"
                        rules={[
                          {
                            required: true,
                            message: "This is a mandatory field",
                          },
                        ]}
                        initialValue={
                          parentReelDetails.rewinding_date
                            ? moment(
                                parentReelDetails.rewinding_date,
                                "YYYY-MM-DD"
                              )
                            : null
                        }
                      >
                        <DatePicker
                          format={"DD-MM-YYYY"}
                          disabledDate={(current) => {
                            return (
                              current && current < moment().subtract(1, "day")
                            );
                          }}
                        />
                      </Form.Item>
                    </DatePickerY>
                  ) : (
                    <DatePickerY>
                      <Form.Item
                        name="cuttingDate"
                        className="dBlock"
                        rules={[
                          {
                            required: true,
                            message: "This is a mandatory field",
                          },
                        ]}
                        initialValue={
                          parentReelDetails.cutting_date
                            ? moment(
                                parentReelDetails.cutting_date,
                                "YYYY-MM-DD"
                              )
                            : null
                        }
                      >
                        <DatePicker
                          format={"DD-MM-YYYY"}
                          disabledDate={(current) => {
                            return (
                              current && current < moment().subtract(1, "day")
                            );
                          }}
                        />
                      </Form.Item>
                    </DatePickerY>
                  )} */}
                </div>

                {/* {parentReelDetails.machine_type === "rewinder" ? (
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Rewinding Shift</h5>
                      <p>The reel will be rewinded on selected shift</p>
                    </div>
                    <Form.Item
                      name="rewindingShift"
                      rules={[]}
                      className="selectForm"
                      initialValue={parentReelDetails.rewinding_shift}
                    >
                      <Select
                        placeholder="Select"
                        suffixIcon={<DownArrowDraw />}
                      >
                        {shiftData?.map((shift) => (
                          <Option key={shift}>{shift}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                ) : (
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Cutting Shift</h5>
                      <p>The sheet will be cut on selected shift</p>
                    </div>
                    <Form.Item
                      name="cuttingShift"
                      rules={[]}
                      className="selectForm"
                      initialValue={parentReelDetails.cutting_shift}
                    >
                      <Select
                        placeholder="Select"
                        suffixIcon={<DownArrowDraw />}
                      >
                        {shiftData?.map((shift) => (
                          <Option key={shift}>{shift}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                )} */}

                <div
                  className="drawerField"
                  style={{ paddingTop: "5px", paddingBottom: "15px" }}
                >
                  <div className="titleWithText titlebytwo" style={{marginTop:"11px"}}>
                    <h5>Jumbo Rolls</h5>
                    <p>You can join multiple jumbo rolls</p>
                    {/* <p>Required Deckle: {""}{(parentReelDetails.size + parentReelDetails.left_edge_trim + parentReelDetails.right_edge_trim)}{" "}
                    {lengthUnit[parentReelDetails.units.size]?.displayName?.toUpperCase()}  */}
                    <p>Required Deckle: {""} {requiredDeckle}{" "}{requiredDeckle ? (lengthUnit[parentReelDetails.units.size]?.displayName?.toUpperCase()) : ""}
                    {"  |  "} Required Weight: {""} ({parentReelDetails?.weight.toFixed(3)}{" "}
                      {parentReelDetails?.units &&
                      parentReelDetails?.units?.weight
                        ? capitalize(
                            weightUnit[parentReelDetails.units.weight]
                              ?.displayName
                          )
                        : "T"}) </p>
                  </div>
                </div>

                {mappedJumboRolls.length === 0 ? (
                  <div className="qualityToggled">
                    <GlobalSet style={{ textAlign: "left", marginTop: "16px" }}>
                      <Button
                        className="textTypeBtn textBtnIcon"
                        style={{ marginLeft: "0" }}
                        onClick={() => addJumboRoll()}
                      >
                        <Iconmoon icon="addcircle" size={14} color="#EA655B" />
                        Add a jumbo roll
                      </Button>
                    </GlobalSet>
                  </div>
                ) : (
                  mappedJumboRolls?.map((reel, index) => {
                    return (
                      <div className="qualityToggled">
                        {index === mappedJumboRolls.length - 1 && (
                          <GlobalSet
                            style={{ textAlign: "left", marginTop: "16px" }}
                          >
                            <Button
                              className="textTypeBtn textBtnIcon"
                              style={{ marginLeft: "0" }}
                              onClick={() => addJumboRoll()}
                            >
                              <Iconmoon
                                icon="addcircle"
                                size={14}
                                color="#EA655B"
                              />
                              Add a jumbo roll
                            </Button>
                          </GlobalSet>
                        )}
                        <div>
                          <div
                            className="drawerField"
                            style={{ paddingTop: "0" }}
                          >
                            <div
                              className="titleWithText dFlex"
                              style={{
                                justifyContent: "space-between",
                                margin: "10px 0 6px",
                              }}
                            >
                              <h5 style={{ alignSelf: "center" }}>
                                Jumbo Roll {index + 1}
                              </h5>
                              <GlobalSet className="specialBtn">
                                <Button
                                  className="textTypeBtn textBtnIcon"
                                  onClick={() => deleteJumboRoll(index)}
                                >
                                  <Iconmoon
                                    icon="delete"
                                    size={14}
                                    color="#EA655B"
                                  />
                                  Delete
                                </Button>
                              </GlobalSet>
                            </div>
                            {(tabNo == 6 || parentReelDetails.machine_type === "rewinder") ? (
                              <h6 className="utilizedtxt">
                                You can select a jumbo roll and specify weight
                                which will be utilized to rewind this parent
                                reel
                              </h6>
                            ) : (
                              <h6 className="utilizedtxt">
                                You can select a jumbo roll and specify weight
                                which will be utilized to cut this parent set
                              </h6>
                            )}
                            {(tabNo == 6 || parentReelDetails.machine_type === "rewinder") ? ( 
                            <Form.Item
                              name={`jumboRoll${index}`}
                              rules={[
                                {
                                  required: action === "save" && true,
                                  message: "This is a mandatory field",
                                },
                              ]}
                              initialValue={type == "edit" ? (reel.number) : ((drawerState ? reel.number : ""))}
                              className="selectForm"
                            >
                              <Select
                                placeholder="Select"
                                suffixIcon={
                                  jumboRoleDropdown ? (
                                    <DropDownSearchDraw />
                                  ) : (
                                    <DownArrowDraw />
                                  )
                                }
                                value={
                                  mappedJumboRolls[index].number || undefined
                                }
                                showSearch
                                onBlur={onJumboRoleDropdown}
                                onFocus={onJumboRoleDropdown}
                                onChange={(e) =>
                                  handleJumboRollChange(index, e)
                                }
                                // allowClear
                                dropdownRender={(menu) => (
                                  <>
                                    {menu}
                                    <Divider style={{marginBottom:"1px"}} />
                                    <Space>
                                      <GlobalSet className="specialBtn">
                                        <Button
                                          className="textTypeBtn textBtnIcon"
                                          style={{ marginLeft: "0", border:"none" }}
                                          onClick={() => creteNewJumbo()}
                                        >
                                          <Iconmoon
                                            icon="addcircle"
                                            size={14}
                                            color="#EA655B"
                                          />
                                          Create new jumbo
                                        </Button>
                                      </GlobalSet>
                                    </Space>
                                  </>
                                )}
                                
                                options={jumboReelData.map((jumboReel) => ({ label: jumboReel.number + "(" + jumboReel.remainingWeight + " " + capitalize(
                                      weightUnit[jumboReel.weight]?.displayName
                                    ) + ")", value: jumboReel.number}))}
                              />
                            </Form.Item>) : (
                              <Form.Item
                              name={`jumboRoll${index}`}
                              rules={[
                                {
                                  required: action === "save" && true,
                                  message: "This is a mandatory field",
                                },
                              ]}
                              initialValue={type == "edit" ? (reel.number) : ""}
                              className="selectForm"
                            >
                              <Select
                                placeholder="Select"
                                suffixIcon={
                                  jumboRoleDropdown ? (
                                    <DropDownSearchDraw />
                                  ) : (
                                    <DownArrowDraw />
                                  )
                                }
                                value={
                                  mappedJumboRolls[index].number || undefined
                                }
                                showSearch
                                onBlur={onJumboRoleDropdown}
                                onFocus={onJumboRoleDropdown}
                                onChange={(e) =>
                                  handleJumboRollChange(index, e)
                                }>
                                {jumboReelData?.map((jumboReel, index) => (
                                  <Option key={jumboReel.number}>
                                    {jumboReel.number} (
                                    {jumboReel.remainingWeight}{" "}
                                    {capitalize(weightUnit[jumboReel.weight]?.displayName                                    )}
                                    )
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                            )}
                            {responseError && (
                              <span
                                className="errorText"
                                style={{ color: "#ea4e2c" }}
                              >
                                {responseError}
                              </span>
                            )}

                            <h6 className="utilizedtxt">
                              Weight to be utilized
                            </h6>
                            <div className="boxFormType sideplace">
                              <Form.Item
                                name={`weight${index}`}
                                className="textareaField"
                                rules={[
                                  {
                                    required: action === "save" && true,
                                    message: "This is a mandatory field",
                                  },
                                  {
                                    pattern: new RegExp(/^-?\d+(\.\d+)?$/),
                                    message: "Only numeric inputs are allowed",
                                  },
                                  {
                                    validator: (_, value) => {
                                      if (!value) return Promise.resolve();
                                      // if (value > parentReelDetails.weight) {
                                      //   return Promise.reject(
                                      //     "Weight cannot be greater than parent reel weight"
                                      //   );
                                      // } else
                                      if ((
                                        +value >
                                        +jumboReelData.filter((item) => {
                                          return (
                                            item.number ===
                                            mappedJumboRolls[index].number
                                          );
                                        })[0]?.remainingWeight) && action !== "remove"
                                      ) {
                                        return Promise.reject(
                                          "Weight cannot be greater than remaining weight"
                                        );
                                      } else return Promise.resolve();
                                    },
                                  },
                                ]}
                                initialValue={ type =="edit" ? (reel.weight_utilized) : (mappedJumboRolls?.length == 1 ? parentReelDetails?.weight.toFixed(3) : "")}
                              >
                                <Input
                                  placeholder=""
                                  name="test"
                                  onChange={(e) =>
                                    setMappedJumboRolls(
                                      mappedJumboRolls.map((obj, key) => {
                                        if (key === index) {
                                          return {
                                            ...obj,
                                            weight_utilized: parseFloat(
                                              e.target.value
                                            ),
                                            units: {
                                              weight_utilized:
                                                parentReelDetails?.units &&
                                                parentReelDetails?.units?.weight
                                                  ? parentReelDetails?.units
                                                      ?.weight
                                                  : "t",
                                            },
                                          };
                                        }
                                        return obj;
                                      })
                                    )
                                  }
                                />
                              </Form.Item>
                              <span className="nonEditable">
                                {parentReelDetails?.units &&
                                parentReelDetails?.units?.weight
                                  ? capitalize(
                                      weightUnit[parentReelDetails.units.weight]
                                        ?.displayName
                                    )
                                  : "T"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                )}

                        {/* <div>
                            <GlobalSet
                            style={{ textAlign: "left", marginTop: "16px" }}
                          >
                            <Button
                              className="textTypeBtn textBtnIcon"
                              style={{ marginLeft: "0" }}
                              // onClick={() => createNewJumbo()}
                            >
                              <Iconmoon
                                icon="addcircle"
                                size={14}
                                color="#EA655B"
                              />
                              Create new jumbo
                            </Button>
                          </GlobalSet>
                        </div> */}

                <div className="buttonFlex fixedBtm">
                  <Form.Item>
                    <Button
                      className="themeBtn noBg"
                      onClick={() => handleSubmit("save")}
                      loading={isSaving}
                    >
                      {!isSaving && <Iconmoon icon="correct" size={16} color="#EA655B" />} Save
                      Mapping
                    </Button>
                  </Form.Item>
                  <Form.Item>
                    <Button className="themeBtn noBg" onClick={showModal}>
                      <Iconmoon icon="wrong" size={16} color="#EA655B" />
                      Remove Mapping
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </HaberForm>
          </DetailFields>
        </div>

        <ConfirmationModal
          visible={visibleModal}
          icon={warning}
          cancelAction={modalClose}
          confirmAction={modalConfirm}
        >
          <span>Remove Mapping ?</span>
          {parentReelDetails.machine_type !== "cutter" ? (
            <p>
              {" "}
              All mappings will be removed for this parent reel. Are you sure
              you want to continue?
            </p>
          ) : (
            <p>
              {" "}
              All mappings will be removed for this parent set. Are you sure you
              want to continue?
            </p>
          )}
        </ConfirmationModal>
        
        <ConfirmationModal
          visible={confirmModalVisible}
          icon={warning}
          cancelAction={handleModalClose}
          confirmAction={handleModalConfirm}
        ><span> Are you sure ?</span>
            <p>
              {" "}
              As the ply count is {jobCardPly}, it is recommended that you add jumbo rolls in multiples of {jobCardPly}.
            </p>
        </ConfirmationModal>

      </RightDrawerContainer>
    </RightDrawerSidebar>
  ) : null;
};

export default MapToJumboDrawer;
